import React, { useState } from "react";
import { useSnackbar } from "notistack";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKCheckbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function NewsletterSignup() {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);

  const handleSubscribe = () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      enqueueSnackbar("Please enter a valid email address.", { variant: "warning" });
      return;
    }
    if (!consent) {
      enqueueSnackbar("You must agree to receive emails.", { variant: "error" });
      return;
    }
    enqueueSnackbar("Thanks for subscribing!", { variant: "success" });
    setEmail("");
    setConsent(false);
  };

  return (
    <MKBox
      mt={6}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      textAlign="center"
    >
      <MKTypography variant="h6" fontWeight="medium">
        Subscribe to Our Newsletter
      </MKTypography>

      <MKBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems="center"
        justifyContent="center"
        gap={2}
        width="100%"
      >
        <MKInput
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ width: { xs: "100%", sm: "300px" } }}
        />
        <MKButton onClick={handleSubscribe} color="info">
          Subscribe
        </MKButton>
      </MKBox>

      <FormControlLabel
        control={
          <MKBox component={MKCheckbox} checked={consent} onChange={() => setConsent(!consent)} />
        }
        label={
          <MKTypography variant="caption" color="text">
            I agree to receive emails and marketing updates.
          </MKTypography>
        }
      />
    </MKBox>
  );
}
